import { forwardRef, ReactElement, useState } from 'react'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import { Button } from '@components/common'
import CloseSvg from '@svgs/close.svg'
import { IClosure } from '@store/features/closure/closure.types'

import { StyledDialog, StyledIcon } from './styled'
import { ClosuresDialogKeysEnum } from './types'
import ClosuresList from './components/ClosuresList'
import ClosureForm from './components/ClosureForm'

interface Props {
  courseName: string
  courseId: string
  isOpen: boolean
  close: () => void
  closures: IClosure[]
  refetch: () => Promise<void>
}

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

const ClosuresDialog = ({ courseName, courseId, isOpen, close, closures, refetch }: Props) => {
  const [dialogType, setDialogType] = useState(ClosuresDialogKeysEnum.closuresList)
  const [selectedClosureId, setSelectedClosureId] = useState<string | undefined>()

  const handleNextStep = (closureId?: string) => {
    setSelectedClosureId(closureId)
    setDialogType(ClosuresDialogKeysEnum.editOrCreateClosure)
  }

  const foundClosure = closures.find((c) => c.id === selectedClosureId)

  const reloadModal = async () => {
    await refetch()
    setDialogType(ClosuresDialogKeysEnum.closuresList)
  }

  const stepsProps = {
    next: handleNextStep,
    courseId,
    closureId: selectedClosureId,
    closures,
    closure: foundClosure,
    courseName,
    reload: reloadModal,
    close
  }

  const components = {
    [ClosuresDialogKeysEnum.closuresList]: <ClosuresList {...stepsProps} />,
    [ClosuresDialogKeysEnum.editOrCreateClosure]: <ClosureForm {...stepsProps} />
  }

  return (
    <StyledDialog
      open={isOpen}
      onClose={close}
      TransitionComponent={Transition}
      aria-describedby='closures-dialog'
    >
      <StyledIcon src={CloseSvg} alt='close icon' onClick={close} />
      {components[dialogType]}
      {dialogType !== 'editOrCreateClosure' ? (
        <Button
          sx={{
            height: '50px'
          }}
          color='primary'
          type='button'
          variant='contained'
          onClick={() => handleNextStep(selectedClosureId)}
        >
          Add Course Closure
        </Button>
      ) : null}
    </StyledDialog>
  )
}

export default ClosuresDialog
